'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: flex-start;\n  width: 100%;\n\n  a, button {\n    margin: 0.25rem;\n    text-decoration: none;\n    font-size: 0.7rem;\n    font-weight: 400;\n    color: #0275d8;\n    border: none;\n    background-color: transparent;\n    cursor: pointer;\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: flex-start;\n  width: 100%;\n\n  a, button {\n    margin: 0.25rem;\n    text-decoration: none;\n    font-size: 0.7rem;\n    font-weight: 400;\n    color: #0275d8;\n    border: none;\n    background-color: transparent;\n    cursor: pointer;\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LinkGroup = _styledComponents2.default.div(_templateObject);

/** @class LinkGroup
  * A component containing one or more links or buttons.
  */
exports.default = LinkGroup;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/auth/link-group.js
// module id = 395
// module chunks = 0